import Meta from '@/components/common/Meta'

import AffordableStorageRatesPage from '@/v2/components/pages/landing-pages/affordable-storage-rates-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/affordable-storage-rates-page'

interface AffordableStorageRatesPageProps {}

const Page: React.FC<AffordableStorageRatesPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.affordable_storage_rates.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.affordable_storage_rates?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.affordable_storage_rates?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <AffordableStorageRatesPage />
    </>
  )
}

export default Page
